import { from } from 'rxjs';
import * as BookingAPI from './BookingAPI';

export const getMbookingProductList = ({shopId, lang}) => from(BookingAPI.getMbookingProductList({shopId, lang}));

export const getMbookingProductAvaliableTimeslot = ({shopId, productId, branchId, date, lang}) => from(BookingAPI.getMbookingProductAvaliableTimeslot({shopId, productId, branchId, date, lang}));

export const submitMbooking = (parameter) => from(BookingAPI.submitMbooking(parameter));

export const getMbookingRecordList = (parameter) => from(BookingAPI.getMbookingRecordList(parameter));

export const getMbookingRecord = (parameter) => from(BookingAPI.getMbookingRecord(parameter));

export const getMbookingProductTimeslotGroup = (parameter) => from(BookingAPI.getMbookingProductTimeslotGroup(parameter));

export const cancelMbooking = (parameter) => from(BookingAPI.cancelMbooking(parameter));
